import React, { useState } from "react";
import {
  ArrowLeft,
  ArrowRight,
  Building2,
  CheckCircle2,
  RefreshCw,
  ShieldCheck,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";

import { message } from "antd";
import axios from "axios";
import AppButton from "../../../components/common/appButton/AppButton";
import { BASE_URL } from "../../../config/config";

const VerifyOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email || "";
  const role = location.state?.role;
  const from = location.state?.from || "";


  console.log(email,role,from,"datatatat")

  const [otpValue, setOtpValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // After OTP is successfully verified
  const [isVerified, setIsVerified] = useState(false);

  const isAccountCreation = from === "accountCreation";


  const handleVerify = async () => {
    if (otpValue.length !== 6) {
      setError("Please enter the 6-digit verification code.");
      return;
    }
    setLoading(true)
    setError("");
    console.log(otpValue,"Otpvalue");
    const payload = {
      email : email,
      otp:otpValue
    }
    try {
      const endpoint = role === "customer" ? "investor/verify-otp" : "owner/verify-otp";
      const response = await axios.post(`${BASE_URL}/${endpoint}`,payload);
      console.log(response,"Response");
      const res = response?.data;
      const token = res?.access_token;
      if(response?.data){
        if(res?.email_verified){
          message.success("Email Verified SuccessFully");
        }
        if(!res?.registration_completed){
          if(role === "customer"){
      navigate("/customer/register/complete-registration",{
            state: {
              token: token || "",
              email:email,
              role: "customer",
            },
          })
    }else{
      navigate("/agent/register/complete-registration",{
            state: {
              token: token || "",
              email : email,
              role: "owner",
            },
          })
    }
        }
      }
    } catch (error) {
      console.log(error,"Error");
      message.error(error?.response?.data?.detail || error?.response?.data?.detail[0]?.msg || "Something Went Wrong. Please Try Again.");
      // navigate(-1)
    }finally{
      setLoading(false)
    }
  };

  const handleOtpChange = (otp) => {
    setOtpValue(otp);

    if (error) {
      setError("");
    }
  };

  const handleResend = () => {
    setOtpValue("");
    setError("");

    console.log("Resend OTP");

    // Resend OTP API can be added here.
  };

  /*
   * Continue Registration
   */
  const handleContinueRegistration = () => {
    const detailsRoute =
      role === "customer"
        ? "/customer/register/details"
        : "/agent/register/details";

    navigate(detailsRoute, {
      state: {
        email,
        role,
        from: "registrationChoice",
      },
    });
  };

  /*
   * Not Now
   */
  const handleNotNow = () => {
    navigate("/login");
  };

  /*
   * Back button
   */
  const handleBack = () => {
    if (isVerified) {
      setIsVerified(false);
      setOtpValue("");
      return;
    }

    navigate(-1);
  };

  return (
    <main className="min-h-screen w-full bg-white text-[#1f2318]">
      <section className="flex min-h-screen w-full">

        {/* ================= LEFT PANEL ================= */}

        <div className="relative hidden w-[55.5%] overflow-hidden lg:block">

          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage:
                'url("https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1600&q=85")',
            }}
          />

          <div className="absolute inset-0 bg-gradient-to-b from-[#1b2815]/10 via-[#172114]/20 to-[#172114]/80" />

          <div className="absolute inset-0 bg-gradient-to-r from-[#172114]/20 via-transparent to-transparent" />

          {/* Logo */}

          <div className="absolute left-8 top-8 z-10 flex items-center gap-2.5 sm:left-10 sm:top-9">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg border border-white/35 bg-white/15 text-white backdrop-blur-md">
              <Building2
                size={15}
                strokeWidth={2.2}
              />
            </div>

            <span className="text-[14px] font-semibold tracking-[-0.01em] text-white">
              GT
            </span>
          </div>

          {/* UAE badge */}

          <div className="absolute right-8 top-8 z-10 rounded-full border border-white/25 bg-white/10 px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[0.12em] text-white backdrop-blur-md sm:right-10 sm:top-9">
            UAE REAL ESTATE
          </div>

          {/* Editorial content */}

          <div className="absolute bottom-8 left-8 right-8 z-10 sm:bottom-10 sm:left-10 sm:right-10">

            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1.5 backdrop-blur-xl">
              <span className="h-1.5 w-1.5 rounded-full bg-[#b8d58f]" />

              <span className="text-[9px] font-semibold uppercase tracking-[0.16em] text-white">
                Secure access
              </span>
            </div>

            <h2 className="max-w-[620px] font-['Playfair_Display'] text-[42px] leading-[1.04] tracking-[0.035em] text-white xl:text-[48px]">
              Your property journey,
              <br />
              <span className=" font-medium text-[#dceac9]">
                starts here.
              </span>
            </h2>

            <p className="mt-4 max-w-[470px] text-[12px] leading-5 text-white/70">
              A secure verification process designed
              for modern UAE real estate investing.
            </p>

            <div className="mt-7 flex max-w-[470px] items-center gap-2 rounded-2xl border border-white/15 bg-black/10 px-4 py-3 backdrop-blur-xl">

              <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-white/10 text-white">
                <ShieldCheck size={14} />
              </div>

              <div>
                <p className="text-[9px] font-semibold uppercase tracking-[0.12em] text-white/50">
                  Protected
                </p>

                <p className="mt-0.5 text-[10px] text-white/80">
                  Your information stays secure.
                </p>
              </div>

            </div>
          </div>
        </div>

        {/* ================= RIGHT PANEL ================= */}

        <div className="relative flex min-h-screen w-full items-center justify-center bg-white px-5 py-8 sm:px-8 lg:w-[44.5%] lg:px-10">

          {/* Back */}

          <button
            type="button"
            onClick={handleBack}
            className="absolute left-5 top-6 inline-flex items-center gap-2 rounded-full border border-[#e5e9e1] bg-[#fbfcf9] px-3.5 py-2 text-[10px] font-semibold text-[#596257] shadow-sm transition hover:border-[#cfd9c7] hover:bg-[#f5f8f1] sm:left-8 sm:top-8"
          >
            <ArrowLeft size={13} />
            Back
          </button>

          <div className="w-full max-w-[470px]">

            {/* ================= REGISTRATION CHOICE POPUP ================= */}
            {isVerified && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#172114]/35 px-5 backdrop-blur-md">
                <div className="w-full max-w-[440px] animate-[fadeIn_0.25s_ease-out] rounded-[24px] border border-[#e1e8dc] bg-white p-6 shadow-[0_25px_80px_rgba(31,48,25,0.18)] sm:p-7">
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#edf5e8] text-[#4c7a2e]">
                    <CheckCircle2 size={24} strokeWidth={2} />
                  </div>

                  <div className="mt-5">
                    <div className="text-[9px] font-bold uppercase tracking-[0.15em] text-[#4c7a2e]">
                      Email verified
                    </div>

                    <h2 className="mt-2 font-['Playfair_Display'] text-[30px] leading-[1.08] tracking-[-0.03em] text-[#1f2318] sm:text-[34px]">
                      Continue your
                      <span className="block italic font-medium text-[#4c7a2e]">
                        registration?
                      </span>
                    </h2>

                    <p className="mt-3 text-[11px] leading-5 text-[#858b82]">
                      Your email has been successfully verified. Would you like
                      to complete the remaining profile information now?
                    </p>
                  </div>

                  <div className="mt-7 space-y-2.5">
                    <button
                      type="button"
                      onClick={handleContinueRegistration}
                      className="group flex w-full items-center justify-between rounded-[14px] bg-[linear-gradient(180deg,#6fa142_0%,#4c7a2e_55%,#375c20_100%)] px-4 py-3.5 text-left text-white shadow-[0_10px_24px_rgba(76,122,46,0.18)] transition hover:-translate-y-px"
                    >
                      <span>
                        <span className="block text-[12px] font-semibold">
                          Yes, Continue Registration
                        </span>
                        <span className="mt-0.5 block text-[9px] text-white/70">
                          Complete your remaining information
                        </span>
                      </span>
                      <ArrowRight
                        size={16}
                        className="transition-transform group-hover:translate-x-1"
                      />
                    </button>

                    <button
                      type="button"
                      onClick={handleNotNow}
                      className="flex w-full items-center justify-center rounded-[14px] border border-[#e1e6dd] bg-[#fafbf8] px-4 py-3.5 text-[11px] font-semibold text-[#5f675b] transition hover:border-[#cfd9c7] hover:bg-[#f3f6ef] hover:text-[#375c20]"
                    >
                      No, Go to Login
                    </button>
                  </div>

                  <div className="mt-5 border-t border-[#e8ece5] pt-4">
                    <p className="text-center text-[9px] leading-4 text-[#9a9f96]">
                      You can complete your registration later after signing
                      in again.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* ================= OTP STATE ================= */}
            <div>
              <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-[#dce8d2] bg-[#f3f8ed] px-3 py-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-[#5f8f37]" />
                <span className="text-[9px] font-bold uppercase tracking-[0.14em] text-[#4c7a2e]">
                  Verification
                </span>
              </div>

              <h1 className="font-['Playfair_Display'] text-[34px] leading-[1.08] tracking-[-0.035em] text-[#1f2318] sm:text-[40px]">
                Verify your email
                <br />
                {/* <span className="italic font-medium text-[#4c7a2e]">
                  .
                </span> */}
              </h1>

              <p className="mt-4 max-w-[400px] text-[12px] leading-5 text-[#858b82]">
                We've sent a 6-digit verification code to
                <span className="ml-1 font-semibold text-[#4c7a2e]">
                  {email}
                </span>
              </p>

              <div className="mt-8 rounded-[20px] border border-[#e4e9df] bg-[#fbfcf9] p-5 shadow-[0_15px_45px_rgba(47,67,36,0.06)] sm:p-6">
                <p className="mb-4 text-[9px] font-bold uppercase tracking-[0.14em] text-[#7c8876]">
                  Enter verification code
                </p>

                <OtpInput
                  value={otpValue}
                  onChange={handleOtpChange}
                  numInputs={6}
                  shouldAutoFocus
                  inputType="tel"
                  isInputNum
                  containerStyle={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "clamp(6px, 1.8vw, 12px)",
                    width: "100%",
                  }}
                  renderInput={(props, index) => (
                    <input
                      {...props}
                      key={index}
                      autoComplete={index === 0 ? "one-time-code" : "off"}
                      inputMode="numeric"
                      aria-label={`Verification digit ${index + 1}`}
                      style={{
                        width: "clamp(38px, 9vw, 52px)",
                        height: "clamp(48px, 11vw, 58px)",
                        fontSize: "clamp(19px, 4vw, 25px)",
                        fontWeight: "600",
                        borderRadius: 10,
                        padding: 0,
                        textAlign: "center",
                        color: "#1f2318",
                        background: "#ffffff",
                        border: "1px solid #dfe5da",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                  )}
                />

                {error && (
                  <p className="mt-3 rounded-lg bg-[#fdf0ee] px-3 py-2 text-[10px] font-medium leading-4 text-[#b45850]">
                    {error}
                  </p>
                )}

                <div className="mt-6">
                  <AppButton
                    type="button"
                    loading={loading}
                    disabled={otpValue.length !== 6}
                    onClick={handleVerify}
                  >
                    <span>{loading ? "Processing...." : "Verify Email"}</span>
                    <ArrowRight size={15} strokeWidth={2} className="ml-1.5" />
                  </AppButton>
                </div>

                <div className="mt-6 text-center">
                  <p className="text-[10px] text-[#92968e]">
                    Didn't receive the code?
                  </p>
                  <button
                    type="button"
                    onClick={handleResend}
                    className="mt-2 inline-flex items-center gap-1.5 text-[11px] font-semibold text-[#4c7a2e] transition hover:text-[#375c20]"
                  >
                    <RefreshCw size={12} strokeWidth={2} />
                    Resend code
                  </button>
                </div>

                <div className="my-6 h-px bg-[#e8ece5]" />

                <p className="text-center text-[9px] leading-4 text-[#92968e]">
                  For your security, never share your verification code with
                  anyone.
                </p>
              </div>
            </div>

            {/* Footer */}

            {/* <p className="mt-7 text-center text-[9px] text-[#a0a59e]">
              Terra · UAE Real Estate
            </p> */}

          </div>
        </div>
      </section>
    </main>
  );
};

export default VerifyOtp;


